import { useSiloConfiguration } from '@silo/config-legacy';
import { AssetKeyLegacy, ChecksumAddress } from '@silo/types';
import { useSiloWeb3 } from '@silo/web3';
import { getIsCurveLpAsset } from 'app/features/util/curve-lp';

export const useIsCurveLpAsset = (siloAddress: ChecksumAddress, assetKey: AssetKeyLegacy): boolean => {
  const { protocolInstance } = useSiloWeb3();
  const { getConfigurationForSilo } = useSiloConfiguration(protocolInstance);
  const siloConfig = getConfigurationForSilo(siloAddress);

  return getIsCurveLpAsset(siloConfig, assetKey);
};
